import { render, staticRenderFns } from "./firmaListesi.vue?vue&type=template&id=233b172d&scoped=true&"
import script from "./firmaListesi.vue?vue&type=script&lang=js&"
export * from "./firmaListesi.vue?vue&type=script&lang=js&"
import style0 from "./firmaListesi.vue?vue&type=style&index=0&id=233b172d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233b172d",
  null
  
)

export default component.exports